import { render, staticRenderFns } from "./PlaceSelect.vue?vue&type=template&id=31d83e4b&"
import script from "./PlaceSelect.vue?vue&type=script&lang=js&"
export * from "./PlaceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d83e4b')) {
      api.createRecord('31d83e4b', component.options)
    } else {
      api.reload('31d83e4b', component.options)
    }
    module.hot.accept("./PlaceSelect.vue?vue&type=template&id=31d83e4b&", function () {
      api.rerender('31d83e4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/selects/PlaceSelect.vue"
export default component.exports